
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AsHeadline from '@/components/Ui/AsHeadline.vue';
    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters(['privacyNotice']);

    export default Vue.extend({
	    name: 'PrivacyNotice',
	    components: {
		    AsModal,
		    AsHeadline,
	    },
    	data(): { component: any } {
	    	return {
		    	component: null,
		    };
	    },
	    computed: {
		    ...settingsHelpers,
		    loader(): any {
			    return () => import(`../PrivacyNotice/${this.privacyNotice}.vue`);
		    },
	    },
	    methods: {
		    loadComponent(name: string): any {
			    return this.loader()
				    .then(() => {
					    this.component = () => this.loader();
				    })
				    .catch(() => {
					    this.component = () => import('../PrivacyNotice/PrivacyNotice.vue');
				    });
		        },
	    },
	    watch: {
		    termsConditions: {
			    handler: 'loadComponent' as any,
			    immediate: true,
		    },
	    },
    });
